export default {"src":"/_next/static/media/laptop-minor.ba6eb7bc.svg","height":67,"width":99};